export default __webpack_public_path__ + "static/media/wizard.50ce7211.png";